import React from 'react';
import { objectSelector } from './utils';

const Error = ({ classes, message, data, field }) => {
  const errorMessage = message || objectSelector(data, field, '');

  return (
    <p
      className={`error ${classes ? classes : ''} ${
        errorMessage ? 'active' : ''
      }`}
    >
      {errorMessage}
    </p>
  );
};

export default Error;



// WEBPACK FOOTER //
// ./src/theme/Error.js